import { NgModule } from "@angular/core";
import { RouterModule, Route } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BrowserModule } from "@angular/platform-browser";
import { FlexLayoutModule } from "@angular/flex-layout";
import { MatSnackBarConfig } from "@angular/material";

import { MaterialAppModule } from "../ngmaterial.module";

import { SessionsComponent, SessionsService } from ".";
import { AdminGuard, AuthenticateGuard } from "../common/guards";
import { CommonModule } from "../common/common.module";
import { GenericTableModule } from "../genericTable";
import { SessionsDisconnectDialogComponent } from "./sessions-disconnect-dialog-component";

export const ROUTES: Route[] = [
	{
		path: "sessions",
		component: SessionsComponent,
		canActivate: [
			AuthenticateGuard,
			AdminGuard
		]
	}
];

@NgModule({
	imports: [
		RouterModule.forRoot(ROUTES),
		FormsModule,
		ReactiveFormsModule,
		BrowserAnimationsModule,
		FlexLayoutModule,
		BrowserModule,
		CommonModule,
		MaterialAppModule,
		GenericTableModule
	],
	declarations: [
		SessionsComponent,
		SessionsDisconnectDialogComponent
	],
	entryComponents: [
		SessionsDisconnectDialogComponent
	],
	providers: [
		MatSnackBarConfig,
		SessionsService
	]
})
export class SessionsModule { }
